import { Box, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import { Autocomplete } from "@material-ui/lab";

interface AutoSearchInputProps<T> {
  value: T | null;
  options: T[];
  onChange: (val: T | null) => void;
  getOptionLabel: (option: T) => string;
  getOptionSelected?: (option: T, value: T) => boolean;
  placeholder?: string;
  isWide?: boolean;
}

export const AutoSearchInput = <T,>({
  value,
  options,
  onChange,
  getOptionLabel,
  getOptionSelected,
  placeholder = "Search",
  isWide,
}: AutoSearchInputProps<T>) => {
  const classes = useStyles();

  return (
    <Box className={`${classes.search} ${isWide ? classes.wideWidth : classes.shortWidth}`}>
      <Box className={classes.searchIcon} color="primary">
        <SearchIcon />
      </Box>
      <Autocomplete
        options={options || []}
        value={value}
        onChange={(_, newValue) => onChange(newValue)}
        getOptionLabel={(option) => getOptionLabel(option) || ""}
        getOptionSelected={getOptionSelected}
        autoHighlight
        classes={{
          root: classes.autocomplete,
          inputRoot: classes.inputRoot,
          input: classes.inputInput,
          endAdornment: classes.endAdornment,
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={placeholder}
            margin="none"
            style={{ margin: 0 }}
          />
        )}
      />
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  search: {
    position: "relative",
  },
  wideWidth: {
    width: 480,
  },
  shortWidth: {
    width: 280,
  },
  autocomplete: {
    width: "100%",
  },
  searchIcon: {
    padding: theme.spacing(0, 1.5),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 5,
    color: "#5F6164",
  },
  endAdornment: {
    right: 8,
  },
  inputRoot: {
    width: "100%",
    color: "inherit",
    paddingTop: "0 !important",
    paddingBottom: "0 !important",
    paddingLeft: `${theme.spacing(0)}px !important`,
    paddingRight: `${theme.spacing(0)}px !important`,
  },
  inputInput: {
    padding: `${theme.spacing(1.3, 6)} !important`,
    width: "100%",
  },
  "@media (max-width: 840px)": {
    wideWidth: {
      width: "100%",
    },
    shortWidth: {
      width: "100%",
    },
  },
}));
